import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientConfiguration, ClientContext } from 'src/app/app.config';
type EnvironmentKey = ClientContext['environment'];
const environmentDisplay: { [key in EnvironmentKey]: string } = {
  Local: 'local',
  Development: 'development',
  Production: 'production',
  QA: 'QA',
  Training: 'training',
};

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private _context = new BehaviorSubject<ClientContext>(clientContext);

  get valueChanges(): Observable<ClientConfiguration> {
    return this._context.asObservable().pipe(map((c) => c.configuration));
  }

  get value(): ClientConfiguration {
    return this._context.getValue().configuration;
  }

  get environmentDisplay(): string {
    return environmentDisplay[this.environmentKey];
  }

  get environmentKey(): EnvironmentKey {
    return this._context.getValue().environment;
  }

  constructor() {}
}
